module.exports = __webpack_public_path__ + "img/reva-animated-waveform.f331552e.gif";